import React from "react";
import { portfolioData as DATA } from "../../data/portfolioData";

export default function Navbar() {
  const items = [
    ["Projects", "#projects"],
    ["Skills", "#skills"],
    ["Experience", "#experience"],
    ["Education", "#education"],
    ["Contact", "#contact"],
  ];

  return (
    <div className="sticky top-0 z-50 border-b border-white/10 bg-black/40 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3">
        <a href="#top" className="font-semibold text-white">
          {DATA.name}
        </a>

        <div className="hidden gap-6 md:flex">
          {items.map(([label, href]) => (
            <a
              key={href}
              href={href}
              className="text-sm text-white/70 hover:text-white"
            >
              {label}
            </a>
          ))}
        </div>

        <a
          href={`mailto:${DATA.email}`}
          className="rounded-xl border border-white/10 bg-white/5 px-3 py-2 text-sm text-white hover:bg-white/10"
        >
          Email
        </a>
      </div>
    </div>
  );
}
